// src/components/ui/BotaoEditarExcluir/ButtonExcluir.jsx
import DeleteIcon from "@mui/icons-material/Delete";

export default function ButtonExcluir({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="p-1"
      style={{
        color: "#bc3823",
        cursor: "pointer",
      }}
      title="Excluir"
    >
      <DeleteIcon fontSize="small" />
    </button>
  );
}
